export const selectActionPlans = (state) => state.actionPlans.plans;
export const selectActionPlanById = (state, id) =>
  state.actionPlans.plans.find((plan) => plan.id === id);
export const selectMostRecentActionPlan = (state) =>
  state.actionPlans.plans[state.actionPlans.plans.length - 1];
